/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class UserPhotoController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags user-photo-controller
   * @name ApiV1UsersUseridPhotoUsingGet
   * @summary getUserPhoto
   * @request GET:/api/v1/users/{userId}/photo
   * @secure
   */
  apiV1UsersUseridPhotoUsingGet = (userId: number, params: RequestParams = {}) =>
    this.request<string, void>({
      path: `/api/v1/users/${userId}/photo`,
      method: "GET",
      secure: true,
      format: "blob",
      ...params,
    });
}
